const STORAGE_PREFIX = 'tutors:editProfileDraft:';
const MAX_AGE_MS = 60 * 60 * 1000; // 1 hour — avoid restoring very stale drafts

export function editProfileDraftKey(tutorId) {
  return `${STORAGE_PREFIX}${tutorId}`;
}

export function saveEditProfileDraft(tutorId, form, savedPhoto) {
  if (tutorId == null) return;
  try {
    const payload = {
      form: { ...form, subjects: [...(form.subjects || [])], modes: [...(form.modes || [])] },
      savedPhoto: savedPhoto != null ? savedPhoto : null,
      savedAt: Date.now(),
    };
    sessionStorage.setItem(editProfileDraftKey(tutorId), JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}

export function readEditProfileDraft(tutorId) {
  if (tutorId == null) return null;
  try {
    const raw = sessionStorage.getItem(editProfileDraftKey(tutorId));
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.form || typeof data.savedAt !== 'number') return null;
    if (Date.now() - data.savedAt > MAX_AGE_MS) {
      sessionStorage.removeItem(editProfileDraftKey(tutorId));
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearEditProfileDraft(tutorId) {
  if (tutorId == null) return;
  try {
    sessionStorage.removeItem(editProfileDraftKey(tutorId));
  } catch {
    /* ignore */
  }
}
